<template>
    <a-modal
            :title="title"
            :width="640"
            :visible="visible"
            @cancel="handleClose"
    >

        <p v-for="record in recordList">
            [兑换时间：{{record.createTime}}，顾客昵称：{{record.userNickname}}，积分：{{record.point}}，使用状态：{{record.status===1?"未使用":"已使用"}}]
        </p>
        <p v-if="recordList.length === 0">无记录</p>

        <template slot="footer">
            <a-button key="submit" type="primary" @click="handleClose">
                确定
            </a-button>
        </template>
    </a-modal>
</template>

<script>

    import vendorAdminService from "../../service/vendorAdmin";
    import {Icon} from "ant-design-vue";
    import moment from "moment"

    export default {
        data () {
            return {
                // Modal统一数据
                dialogData: {},
                title: {},
                visible: false,

                recordList: []
            }
        },
        methods: {
            showModal(data) {
                this.title = "消费券兑换记录"
                this.dialogData = data
                this.visible = true

                vendorAdminService.exchangeRecord( {id: data}).then((res) => {
                    if(res.success === true) {
                        this.recordList = res.data
                        for(let record of this.recordList) {
                            record.createTime = moment(new Date(record.createTime)).format("YYYY-MM-DD HH:mm:ss")
                        }
                    } else {
                        this.$notification.open({
                            message: '消费券兑换记录获取失败！',
                            description: res.data.message,
                            icon: (h) => {
                                return h(Icon, {
                                    attrs: {type: 'close-circle', style: 'color: red'}
                                });
                            }
                        });
                    }
                })
            },
            handleClose () {
                this.visible = false
            },
        }
    }
</script>

<style scoped>

</style>
